import React,{useEffect} from "react";
import DisplaySales from "../components/dataDisplay/DisplaySales";
import { setSelectedSale ,deleteSale,clearSelectedSale,clearAlerts,clearSalesData } from "../store/salesSlice"; // Adjust the path as necessary
import { fetchMouvementTypeById,clearselectedMouvement } from "../store/mouvementTypesSlice";
import { useDispatch, useSelector } from "react-redux";
import MyButton from "../components/MyButton";
import AddIcon from "@mui/icons-material/Add";
import { ACTION_PERMISSIONS, DocumentIdName } from "../services/Enums";
import MyConfirmation from "../components/MyConfirmation";
import { checkCreatePermissionBasedOnMouvementType, checkDeletePermissionBasedOnMouvementType, checkUpdatePermissionBasedOnMouvementType } from "../services/utils";
import useSaleDocument from "../services/useSaleDocument";
import { showSnackbar } from "../store/snackbarSlice";


export default function CommandeManagement() {
  const { selectedMouvement } = useSelector((state) => state.mouvementTypes) || {};
  // const [commandeDialogOpen, setCommandeDialogOpen] = useState(false);
  // const [newCommmandeDialogOpen, setNewCommandeDialogOpen] = useState(false);
  // const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [ConfirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  
  const { selectedSale ,message, error } = useSelector((state) => state.sale) || {};
  

  useEffect(() => {
      if (message || error) {
        const type = message ? "success" : "error";
        const content = message || error;
  
        // Show snackbar with appropriate type
        dispatch(showSnackbar({ message: content, severity: type }));
        dispatch(clearAlerts());
         //dispatch(clearSalesData())
        // Clear the form and fetch articles if successful
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message, error]);
  
    
  // const closeNewCommandeDialog = () => {
  //   if (hasUnsavedChanges) {
  //     const confirmClose = window.confirm(
  //       "You have unsaved changes. Do you really want to close?"
  //     );
  //     if (!confirmClose) return;
  //   }
  //   setNewCommandeDialogOpen(false);
  // };

  const { openSaleDocument, SaleDialog } = useSaleDocument();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMouvementTypeById(DocumentIdName.COMMANDE_CLIENT));
    return () => {
      dispatch(clearselectedMouvement());
      dispatch(clearAlerts())
    };
  }, [dispatch]);
   
  // const openCommandeDialog = () => {
  //   setCommandeDialogOpen(true);
  // };
  // const openNewCommandeDialog = () => {
  //   setNewCommandeDialogOpen(true);
  // };

  // const closeCommandeDialog = () => {
  //   setCommandeDialogOpen(false);
  // };


  const actions = [
    {
      label: "Dispatch",
      type: "update",
      action: checkCreatePermissionBasedOnMouvementType(DocumentIdName.ORDRE_DE_LIVRAISON),
      callback: (item) => {
       dispatch(setSelectedSale(item));  
        openSaleDocument(selectedMouvement,item,true)
      },
    },
    {
      label: "Edit",
      type: "update",
      action: checkUpdatePermissionBasedOnMouvementType(DocumentIdName.COMMANDE_CLIENT),
      callback: (item) => {
       dispatch(setSelectedSale(item));  
        openSaleDocument(selectedMouvement,item,false)
      },
    },
    {
          label: "Delete",
          type: "delete",
          action: checkDeletePermissionBasedOnMouvementType(DocumentIdName.COMMANDE_CLIENT),
          callback: (item) => {
            dispatch(setSelectedSale(item));
            handleOpenConfirmDialog();
          },
        },

  
  ];

  const handleOpenConfirmDialog = () => {
    setConfirmDialogOpen(true);
  };

  const handleConfirm = () => {
    dispatch(deleteSale(selectedSale));
    dispatch(clearSelectedSale());
    setConfirmDialogOpen(false);
  };

  const handleCancel = (item) => {
    dispatch(clearSelectedSale());
    setConfirmDialogOpen(false);
  };

  return (
    <div>
      
      <div style={{marginTop: "20px"}}> 
      <MyButton
          key={selectedMouvement?._id || "default-key"}
          type="create"
          action={ACTION_PERMISSIONS.ADD_COMMANDE}
          onClick={() => openSaleDocument(selectedMouvement)}
        >
          <AddIcon />
          {`Insert ${selectedMouvement?.name || "Type"}`}
        </MyButton>
      </div>

      <DisplaySales actions={actions} isCommande={true} />

    {SaleDialog}

      <MyConfirmation
              open={ConfirmDialogOpen}
              title="Delete Item"
              description={`Are you sure you want to delete this item ? ${
                selectedSale?.numero || ""
              }`}
              onConfirm={handleConfirm}
              onCancel={handleCancel}
              confirmText="Delete"
              cancelText="Cancel"
            />


    </div>
  );
}

